export enum EmailFamily {    
    Cryo = 3,
    DcnDonorTracking = 5,
    FreshBlood = 4,
    Misc = 1,
    Offers = 2
}